import React from 'react';

import {AlignmentRowVisibilityOptionsDropdown} from 'components/DisplayOptions';
import {VisibilityOptions} from 'components/VisibilityOptions';
import {FeatureCounts} from 'components/VisibilityOptionsDropdownView';
import {DNAAlignmentRowType, ProteinAlignmentKind} from 'constants/AlignmentConstants';

export interface AlignmentRowProps {
  alignmentRowType?: DNAAlignmentRowType | ProteinAlignmentKind;
  canEdit: boolean;
  reserveSpaceRight?: boolean;
  options: VisibilityOptions;
  featureCounts?: FeatureCounts;
}

export function AlignmentRow({
  alignmentRowType,
  canEdit,
  reserveSpaceRight,
  options,
  featureCounts,
}: AlignmentRowProps): JSX.Element {
  return (
    <>
      <div className="handle">
        <div id="visibility-options-react-mount">
          <AlignmentRowVisibilityOptionsDropdown options={options} featureCounts={featureCounts} />
        </div>
        <div
          className="alignment-row-info-section"
          style={{height: '100%', width: reserveSpaceRight ? '75%' : '85%'}}
        />
        {alignmentRowType === 'aligned' && canEdit && (
          <span style={{marginLeft: 'auto'}} className="times pull-right">
            &times;
          </span>
        )}
        <div className="slider-container">
          <div style={{height: '100%'}} className="slider" />
        </div>
      </div>
      <div className="content draggable-svg-container" />
    </>
  );
}
